/**
 * @generated SignedSource<<f9fca47f89d011269ede975825c7c48c>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type SettingsPanelQuery$variables = {};
export type SettingsPanelQuery$data = {
  readonly viewer: {
    readonly account: {
      readonly billingAccount: {
        readonly hasAccessToObjectives: boolean;
        readonly hasAccessToTeams: boolean;
      };
    };
    readonly activeDelegation: {
      readonly id: string;
    } | null;
  };
};
export type SettingsPanelQuery = {
  response: SettingsPanelQuery$data;
  variables: SettingsPanelQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "alias": "hasAccessToObjectives",
  "args": [
    {
      "kind": "Literal",
      "name": "feature",
      "value": "objectives"
    }
  ],
  "kind": "ScalarField",
  "name": "hasAccessToFeature",
  "storageKey": "hasAccessToFeature(feature:\"objectives\")"
},
v1 = {
  "alias": "hasAccessToTeams",
  "args": [
    {
      "kind": "Literal",
      "name": "feature",
      "value": "teams"
    }
  ],
  "kind": "ScalarField",
  "name": "hasAccessToFeature",
  "storageKey": "hasAccessToFeature(feature:\"teams\")"
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "concreteType": "Delegation",
  "kind": "LinkedField",
  "name": "activeDelegation",
  "plural": false,
  "selections": [
    (v2/*: any*/)
  ],
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "SettingsPanelQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Account",
            "kind": "LinkedField",
            "name": "account",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "BillingAccount",
                "kind": "LinkedField",
                "name": "billingAccount",
                "plural": false,
                "selections": [
                  (v0/*: any*/),
                  (v1/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          (v3/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "SettingsPanelQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Account",
            "kind": "LinkedField",
            "name": "account",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "BillingAccount",
                "kind": "LinkedField",
                "name": "billingAccount",
                "plural": false,
                "selections": [
                  (v0/*: any*/),
                  (v1/*: any*/),
                  (v2/*: any*/)
                ],
                "storageKey": null
              },
              (v2/*: any*/)
            ],
            "storageKey": null
          },
          (v3/*: any*/),
          (v2/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "2c647c8b0725d31b10e218f994e0af57",
    "id": null,
    "metadata": {},
    "name": "SettingsPanelQuery",
    "operationKind": "query",
    "text": "query SettingsPanelQuery {\n  viewer {\n    account {\n      billingAccount {\n        hasAccessToObjectives: hasAccessToFeature(feature: objectives)\n        hasAccessToTeams: hasAccessToFeature(feature: teams)\n        id\n      }\n      id\n    }\n    activeDelegation {\n      id\n    }\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "82db97ebbbb9513ec2f2244dc3b65aa7";

export default node;
